import { useEffect, useState } from 'react';
import { request } from '../../../interfaces/networkManager';

import Title from './Title';
import { Box,  FormControl, FormControlLabel, Grid, Radio, RadioGroup, Switch } from '@mui/material';
import { Statistics } from '../../../models/statistics';
import ApplicationPicker from '../../../components/Picker/ApplicationPicker';
import OperatingSystemTable from './Statistics/OperatingSystemTable';
import ConnectionTable from './Statistics/ConnectionTable';
import EvolutionByMonth from './Statistics/EvolutionByMonth';

const dateRanges = [
	{ value: '7', label: 'Semaine' },
	{ value: '30', label: 'Mois' },
	{ value: '90', label: 'Trimestre' },
	{ value: '365', label: 'Année' },
];

export enum MODES {
	Table = 'TABLE',
	Chart = 'CHART'
}

export const ConnectionStatistic = () => {
	// Pas besoin de stocker l'erreur si on ne l'affiche pas
	// const [error, setError] = useState<string | null>(null);
	const [statistics, setStatistics] = useState<Statistics | null>(null);
	const [selectedDateRange, setSelectedDateRange] = useState<string>('365');
	const [selectedApplication, setSelectedApplication] = useState<string>("");
	const [loading, setLoading] = useState<boolean>(true);
	const [mode, setMode] = useState<MODES>(MODES.Chart);

	useEffect(() => {
		setLoading(true);
		request<Statistics>(`/connections/statistics?days=${selectedDateRange}${selectedApplication !== null ? `&idApplication=${selectedApplication}` : ''}`)
			.then((response: Statistics) => {
				setStatistics(response);
			})
			.catch((error: string) => {
				console.error('Erreur lors de la récupération des statistiques:', error);
			})
			.finally(() => setLoading(false));
	}, [selectedDateRange, selectedApplication]);

	return (
		<>
			<Title>Connections</Title>
			<Box>	
				<FormControl sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly' }}>
					<Box sx={{ flex: 1 }}>
						<RadioGroup
							row
							name="dateRange"
							value={selectedDateRange}
						onChange={(event) => {
							setSelectedDateRange(event.target.value);
						}}
					>
						{dateRanges.map((dateRange) => (
							<FormControlLabel key={dateRange.value} value={dateRange.value} control={<Radio />} label={dateRange.label} />
						))}
					</RadioGroup>
					</Box>
					<Box sx={{ flex: 1 }}>
						<ApplicationPicker value={selectedApplication} onChange={setSelectedApplication} />
					</Box>
					<Box sx={{ flex: 1, display: 'flex', justifyContent	: 'center' }}>
						<FormControlLabel control={<Switch 
								checked={mode === MODES.Chart}
								onChange={() => setMode(mode === MODES.Chart ? MODES.Table : MODES.Chart)}
								name="mode"
								inputProps={{ 'aria-label': 'controlled' }}
							/>} label={mode === MODES.Chart ? 'Graphique' : 'Tableau'} />
					</Box>
				</FormControl>
				<Grid container spacing={2} mt={1}>
					<Grid size={{xs:12, lg:6}}>
						<ConnectionTable connections={statistics?.connections || []} loading={loading} mode={mode} />	
					</Grid>
					<Grid size={{xs:12, lg:6}}>
						<OperatingSystemTable os={statistics?.os || []} loading={loading} mode={mode} />	
					</Grid>
					<Grid size={{xs:12, lg:6}}>
						<EvolutionByMonth evolution={statistics?.evolution || []} loading={loading} mode={mode} />
					</Grid>
				</Grid>
			</Box>
		</>
	);
};
